module.exports = __webpack_public_path__ + "assets/img/11_473_big.79404e6d.jpg";